import React, { useEffect, useState } from "react";
import {
   Modal,
   Grid, Button,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { loadStripe } from '@stripe/stripe-js';
import Radio from '@mui/material/Radio';
import axios from "axios";
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import { FiChevronLeft } from 'react-icons/fi';
import { FcGoogle } from 'react-icons/fc';
import { FaApple, FaBullseye } from 'react-icons/fa';
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import CircularProgress from "@mui/material/CircularProgress";
import CreatePriceStr from '../../common/common/CreatePriceStr';
import { IoDocumentTextOutline } from "react-icons/io5";

import { Elements, useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';

import '../../../css/Checkout.css';


const paths = require('../../../paths.json');


const LightTooltip = styled(({ className, ...props }) => (
   <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
   [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#222222 !important',
      color: '#ffffff',
      boxShadow: theme.shadows[1],
      fontSize: 11,
      margin: '0px'
   },
}));


const truncateString = (str, maxLength) => {
   if (!str) return '';
   if (str.length <= maxLength) return str;
   return str.slice(0, maxLength) + '...';
};


const CheckoutForm = (props) => {
   const stripe = useStripe();
   const elements = useElements();
   const mobileWidth = 'calc(100% - 30px)';
   const [errorMessage, setErrorMessage] = useState();
   const [loading, setLoading] = useState(false);
   const [currentTab, setCurrentTab] = useState('');


   const handleError = (error) => {
      setLoading(false);
      setErrorMessage(error.message);
   }

   const handleSubmit = async (e) => {
      e.preventDefault();
      if (!stripe || !elements) {
         // Stripe.js has not yet loaded.
         // Make sure to disable form submission until Stripe.js has loaded.
         return;
      }

      setLoading(true);

      // Trigger form validation and wallet collection
      const { error: submitError } = await elements.submit();
      if (submitError) {
         handleError(submitError);
         return;
      }
      const form_data = new FormData();
      form_data.append('influencer', props.influencer)
      form_data.append('collection_id', props.collection_id)
      form_data.append('currency', props.currency)
      form_data.append('price', props.price)

      // Create the subscription
      const res = await axios({
         method: 'post',
         url: paths.BACKEND_URL + "api/checkout/create_collection_intent_direct_payment",
         data: form_data,
         headers: {
            'Content-type': 'application/json',
         },
         withCredentials: true
      })
      if (res.data.error) {
         setLoading(false);
         setErrorMessage('Error, please try again. If it persists please reach out to us.');
      } else {
         const confirmIntent = stripe.confirmPayment;
         const clientSecret = res.data.client_secret
         // Confirm the Intent using the details collected by the Payment Element
         const { error } = await confirmIntent({
            elements,
            clientSecret,
            confirmParams: {
               // ONCE YOU KNOW THE REDIRECT MAGIC LINK IT NEEDS ADDING TO THIS
               return_url: window.location.origin + '/checkout_redirect?creator=' + props.influencer + '&collection_id=' + props.collection_id,
            },
         });

         if (error) {
            // This point is only reached if there's an immediate error when confirming the Intent.
            // Show the error to your customer (for example, "payment details incomplete").
            handleError(error);
         } else {
            // Your customer is redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer is redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
         }
      }
   }


   const handleChange = (event) => {
      setCurrentTab(event.value.type)
   };

   return (
      <form style={{
         minWidth: '290px',
         paddingBottom: window.innerWidth < 900 ? '120px' : '0px',
         width: window.innerWidth < 900 ? mobileWidth : 'calc(100% - 30px)',
         maxWidth: '500px',
         marginTop: '10px'
      }} id="payment-form" onSubmit={handleSubmit}>
         <PaymentElement
            options={{}}
            onChange={handleChange}
            id="payment-element"
         />


         {

            currentTab === 'apple_pay' ?
               <button
                  style={{
                     minWidth: '290px',
                     maxWidth: '500px',
                     width: '100%',
                     marginTop: '20px',
                     paddingTop: '10px',
                     paddingBottom: '10px',
                     backgroundColor: '#000000',
                     border: 'none',
                     outline: 'none',
                     borderRadius: '5px',
                     cursor: 'pointer',
                  }} disabled={loading || !stripe || !elements} id="submit">
                  <span id="button-text" style={{ fontStyle: 'roboto', fontWeight: '600', color: 'white', fontSize: '16px', verticalAlign: 'text-bottom' }}>
                     {loading ? <div className="spinner" id="spinner"><CircularProgress
                        style={{
                           color: 'white', height: '20px', width: '20px', marginTop: '2px',
                        }} /></div> : <span>Buy with <FaApple style={{ fontSize: '20px', marginLeft: '0px', verticalAlign: 'text-bottom', color: 'white', }} /><span style={{ color: 'white', fontSize: '18px', marginLeft: '3px' }}>Pay</span></span>}
                  </span>

               </button>
               :
               <>

                  {

                     currentTab === 'google_pay' ?

                        <button
                           style={{
                              minWidth: '290px',
                              maxWidth: '500px',
                              width: '100%',
                              marginTop: '20px',
                              paddingTop: '10px',
                              paddingBottom: '10px',
                              backgroundColor: '#000000',
                              border: 'none',
                              outline: 'none',
                              borderRadius: '5px',
                              cursor: 'pointer',
                           }} disabled={loading || !stripe || !elements} id="submit">
                           <span id="button-text" style={{ fontStyle: 'roboto', fontWeight: '600', color: 'white', fontSize: '16px', verticalAlign: 'text-bottom' }}>
                              {loading ? <div className="spinner" id="spinner"><CircularProgress
                                 style={{
                                    color: 'white', height: '20px', width: '20px', marginTop: '2px',
                                 }} /></div> : <span>Buy with <FcGoogle style={{ fontSize: '20px', marginLeft: '0px', verticalAlign: 'text-bottom' }} /><span style={{ color: 'white', fontSize: '18px', marginLeft: '3px' }}>Pay</span></span>}
                           </span>

                        </button>

                        :

                        <button
                           style={{
                              minWidth: '290px',
                              maxWidth: '500px',
                              width: '100%',
                              marginTop: '20px',
                              paddingTop: '10px',
                              paddingBottom: '10px',
                              backgroundColor: 'var(--brand-color)',
                              border: 'none',
                              outline: 'none',
                              borderRadius: '5px',
                              cursor: 'pointer',
                           }} disabled={loading || !stripe || !elements} id="submit">
                           <span id="button-text" style={{ fontStyle: 'roboto', fontWeight: '600', color: 'white', fontSize: '16px' }}>
                              {loading ? <div className="spinner" id="spinner"><CircularProgress
                                 style={{
                                    color: 'white', height: '20px', width: '20px', marginTop: '2px',
                                 }} /></div> : <span>Buy</span>}
                           </span>
                        </button>
                  }
               </>
         }



         <div style={{ width: '100%', height: 'auto', textAlign: 'center' }}>
            <p style={{
               paddingBottom: '5px',
               margin: '15px auto 0px auto',
               fontSize: '12px',
               color: '#6D6E78',
               fontWeight: '400',
               lineHeight: 'normal',
               // maxWidth: '320px',
               '&:hover': {
                  cursor: 'pointer'
               }
            }}>By continuing, you confirm you agree to our <a onClick={() => {
               props.open_terms()
            }}
               style={{
                  color: '#6D6E78',
                  textDecoration: 'underline',
                  cursor: 'pointer'
               }}>Member Terms & Conditions</a></p>
         </div>
         {/* Show any error or success messages */}
         {errorMessage && <p style={{ width: '100%', textAlign: 'center', color: 'red', fontSize: '14px', fontWeight: '600', margin: '5px 0px 0px 0px', paddingBottom: '10px' }}>{errorMessage}</p>}
      </form>
   )
}

export default function BuyCollectionCheckout(props) {
   const [postAmount, setPostAmount] = useState(1000);
   const [todayAmount, setTodayAmount] = useState(1000);
   const mobileWidth = 'calc(100% - 30px)';
   const [windowWidth, setWindowWidth] = useState(window.innerWidth)
   const [taxValue, setTaxValue] = useState(0);

   const stripePromise = loadStripe(
      paths.STRIPE_PUBLISHABLE_KEY
   )
   useEffect(() => {
      setWindowWidth(window.innerWidth)
   }, [window.innerWidth])

   const options = props.connected_stripe_account_id ? {
      // passing the client secret obtained from the server
      // layout: {
      //     type: 'accordion',
      //     defaultCollapsed: false,
      //     radios: true,
      //     spacedAccordionItems: false
      // },
      onBehalfOf: props.connected_stripe_account_id,
      mode: 'subscription',
      amount: props.buyCollectionPrice,
      currency: props.currency.toLowerCase(),
      appearance: {
         theme: 'stripe',
         variables: {
            colorPrimary: '#3B55F3',
            colorIcon: '#3B55F3',
         }
      },
   } : {
      mode: 'subscription',
      amount: props.buyCollectionPrice,
      currency: props.currency.toLowerCase(),
      appearance: {
         theme: 'stripe',
         variables: {
            colorPrimary: '#3B55F3',
            colorIcon: '#3B55F3',
         }
      },
   };

   return (
      <Modal
         disableAutoFocus={true}
         sx={{
            // margin: 'auto',
            backgroundColor: 'rgba(0,0,0,0.60)',
            // borderRadius: '5px',
            overflow: 'hidden',
            minWidth: '100vw',
            outline: '0',
            display: 'flex',
            zIndex: '8999',
            lineHeight: '25px',
         }}
         open={props.buyCollectionCheckoutOpen}
         onClose={() => { props.closeBuyCollectionCheckout() }}
      >
         <Grid
            container
            xs={12}
            style={{
               backgroundColor: windowWidth > 900 ? 'transparent' : '#FFF',
               height: '100vh',
               width: '100vw',
               overflow: 'auto',
            }}
            justifyContent={'center'}
            alignItems={'center'}
         >


            <Grid
               xs={12}
               container
               justifyContent={'center'}
               alignItems={'center'}
               style={{
                  background: 'white',
                  width: '100%',
                  maxWidth: '1200px',
                  minHeight: windowWidth >= 900 ? '600px' : (windowWidth < 900 ? '100vh' : 'auto'),
                  height: windowWidth >= 900 ? 'auto' : (windowWidth < 900 ? 'auto' : 'auto'),
                  maxHeight: windowWidth >= 900 ? '600px' : 'auto',
                  padding: '0px 0px',
                  borderRadius: windowWidth >= 900 ? '5px' : '0px',
               }}
            >
               <Grid
                  container
                  item
                  xs={12}
                  md={6}
                  lg={6}
                  justifyContent={'center'}
                  alignItems={'center'}
                  sx={{
                     height: windowWidth >= 900 ? '600px' : 'auto',
                     maxHeight: windowWidth >= 900 ? '600px' : 'auto',
                     backgroundColor: windowWidth < 900 ? '' : '#FFF',
                     width: windowWidth >= 900 ? '100%' : (windowWidth < 500 ? mobileWidth : '500px'),
                     maxWidth: windowWidth >= 900 ? '100%' : (windowWidth < 500 ? '100%' : '500px !important'),
                     position: 'relative',
                     borderTopLeftRadius: '5px',
                     borderBottomLeftRadius: '5px',
                  }}
               >
                  <IconButton
                     style={{
                        padding: '0px',
                        margin: '0px',
                        textAlign: 'left',
                        color: '#9CA3B4',
                        backgroundColor: 'transparent',
                        justifyContent: 'left',
                        minWidth: '30px',
                        position: 'absolute',
                        top: '12.5px',
                        left: '5px',
                        zIndex: '99',
                     }}
                     onClick={() => {
                        props.closeBuyCollectionCheckout()
                     }}
                  >
                     <FiChevronLeft
                        style={{
                           fontSize: '18px',
                           fontWeight: '300',
                           textAlign: 'right',
                           position: 'absolute',
                           padding: '0px',
                           marginTop: '-1px'
                        }}
                        color='#9CA3B4'
                     />
                     <span style={{ fontSize: '14px', paddingLeft: '18px' }}>Back</span>
                  </IconButton>
                  <Grid
                     container
                     xs={12}
                     sx={{
                        maxHeight: windowWidth >= 900 ? 'auto' : 'auto',
                        zIndex: '4',
                        maxWidth: windowWidth >= 900 ? '100%' : mobileWidth,
                        padding: windowWidth >= 900 ? '0px 50px' : '70px 0px 0px 0px',
                     }}
                  >
                     <span style={{ width: windowWidth >= 900 ? '100%' : mobileWidth, textAlign: 'left', fontSize: '15px', marginBottom: '15px', fontWeight: '600', color: '#6E89AF', margin: '0px 0px 15px 0px' }}>Enjoy lifetime access to the collection {truncateString(props.buyCollectionTitle, 30)} and any content that's added in the future</span>
                     <h2 style={{
                        width: windowWidth >= 900 ? '100%' : mobileWidth, textAlign: 'left', fontSize: '32px', margin: '0px 0px 15px 0px', fontWeight: '600',
                     }}>{CreatePriceStr(props.buyCollectionPrice, props.currency)}</h2>

                     <div style={{ display: 'block', width: '100%', margin: '0px 0px 0px 0px' }}>
                        <p>Order Summary</p>
                        <div style={{ width: '100%', height: '1px', backgroundColor: 'rgb(0,0,0,0.1)' }} />
                        <div style={{ display: 'flex', width: '100%', padding: '20px 0px', alignItems: 'center' }}>
                           <div style={{
                              width: '60px',
                              height: '60px',
                              backgroundColor: '#f5f5f5',
                              borderRadius: '10px',
                              marginRight: '15px',
                              backgroundImage: props.buyNowContentType !== 'txt' ? `url(https://openaccessimages.s3.eu-west-2.amazonaws.com/LockedCardEmail.png)` : 'none',
                              backgroundSize: 'cover',
                              backgroundPosition: 'center',
                              display: 'flex',
                           }}>
                              {
                                 props.buyNowContentType === 'txt' ?

                                    <IoDocumentTextOutline style={{ margin: 'auto', color: '#9CA3B3', fontSize: '26px' }} />
                                    : null
                              }
                           </div>
                           <div style={{ flex: 1, justifyContent: 'flex-start' }}>
                              <h3 style={{ margin: '0px 0px 0px 0px', color: '#000', fontSize: '16px', fontWeight: '600', fontFamily: 'Roboto' }}>{truncateString(props.buyCollectionTitle, 30)}</h3>
                              <p style={{ margin: '0px', color: '#666', fontSize: '14px', fontWeight: '500', fontFamily: 'Roboto' }}>{props.influencer_name}</p>
                           </div>
                           <div style={{ textAlign: 'right' }}>
                              <div style={{
                                 backgroundColor: '#e1e4fa',
                                 color: '#3B55F3',
                                 padding: '0px 10px',
                                 borderRadius: '100px',
                                 fontSize: '10px',
                                 fontWeight: '500',
                                 marginBottom: '5px'
                              }}>
                                 Lifetime Access
                              </div>
                              <span style={{
                                 fontSize: '18px',
                                 fontWeight: '600'
                              }}>{CreatePriceStr(props.buyCollectionPrice, props.currency)}
                              </span>
                           </div>
                        </div>

                        {/* <div style={{ width: '100%', height: '1px', backgroundColor: 'rgb(0,0,0,0.1)' }} />

                        <p style={{
                           fontSize: '14.5px', fontWeight: '400', letterSpacing: '0px',
                           padding: '0px 0px 0px 0px', textAlign: 'left !important', margin: '10px 0px 0px 0px'
                        }}>
                           Promo Code
                        </p>

                        <form style={{
                           backgroundColor: '#ffffff', color: '#fff', borderRadius: '5px', padding: '4px 0px', display: 'flex',
                           border: '1px solid #D9DADB', minWidth: '290px', width: '100%', maxWidth: '500px', zIndex: '10', margin: '0px 0px 5px 0px',
                        }}>

                           <input type="text" className={'text-input-with-button checkout-email-field'} id={"emailCaptureInput"}
                              style={{
                                 border: 'none', paddingLeft: '10px', width: '100%', fontWeight: '400', color: '#1D1D1D', fontSize: '16px',
                                 fontFamily: 'Roboto', '& :placeholder': { color: 'red' }
                              }}
                              value={props.edited_promo_code}
                              placeholder="Enter promo code"
                           //  onChange={(event) => {props.setState({edited_promo_code: event.target.value})}}
                           />

                           <Button
                              variant="contained"
                              disableElevation
                              // onClick={() => {props.updateSubscriptionIntent(props.selected_duration, props.edited_promo_code)}}
                              sx={{
                                 padding: '4px 7px',
                                 display: 'inline-block',
                                 marginLeft: 'auto',
                                 marginRight: '4px',
                                 borderRadius: '4px !important',
                                 textTransform: 'none',
                                 backgroundColor: 'var(--brand-color)',
                                 '&:hover': {
                                    backgroundColor: 'var(--brand-color-hover)'
                                 }
                              }}>

                              <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                 Apply
                              </span>
                           </Button>

                        </form>
                        {
                           props.promo_error ?
                              <div style={{ display: 'block', }}>
                                 <p style={{
                                    textAlign: 'left', color: props.promo_error === 'Invalid code' ? '#e03f3f' : '#42cc75', fontSize: '14px', width: 'max-content',
                                    backgroundColor: props.promo_error === 'Invalid code' ? '#fddcdc' : '#e5ffef', padding: '0px 8px', borderRadius: '5px', fontWeight: '600', margin: '10px 0px 0px 0px'
                                 }}>{props.promo_error}</p>
                                 {
                                    props.promo_error === 'Invalid code' ?
                                       <p style={{ textAlign: 'left', color: '#77787D', fontStyle: 'italic', fontSize: '13px', borderRadius: '5px', fontWeight: '600', margin: '10px 0px 0px 0px', lineHeight: '17px' }}>Please try again. Promo codes are case sensitive and should not include any extra spaces.</p>
                                       : null
                                 }

                              </div>
                              : null
                        } */}
                     </div>
                     <div style={{ width: '100%', height: '1px', backgroundColor: 'rgb(0,0,0,0.1)' }} />
                     <div style={{ display: 'flex', width: '100%', margin: '10px 0px 10px 0px', fontSize: '14px'}}>
                        <span style={{ flex: 1 }}>Subtotal</span>
                        <span>{CreatePriceStr(Math.round(props.buyCollectionPrice), props.currency)}</span>
                     </div>
                     {/* <div style={{ display: 'flex', width: '100%', paddingBottom: '10px', fontSize: '14px', }}>
                        <span style={{ flex: 1 }}>Tax</span>
                        <span>{CreatePriceStr(Math.round(props.buyNowCheckoutPrice), props.currency)}</span>
                     </div> */}
                     <div style={{ width: '100%', height: '1px', backgroundColor: 'rgb(0,0,0,0.1)' }} />
                     <div style={{ display: 'flex', width: '100%', paddingTop: '10px' }}>
                        <span
                           style={{
                              flex: 1,
                              fontSize: '14px',
                              fontWeight: '600',
                              margin: '10px 0px 0px 0px'
                           }}
                        >
                           Total due today
                        </span>
                        <span
                           style={{
                              fontSize: '14px',
                              fontWeight: '600',
                              margin: '10px 0px 0px auto'
                           }}
                        >
                           {CreatePriceStr(Math.round(props.buyCollectionPrice), props.currency)}
                        </span>
                     </div>
                     {
                        windowWidth < 900 ?
                           <div style={{ width: '100%', height: '1px', backgroundColor: 'rgb(0,0,0,0.1)' }} />
                           :
                           null
                     }
                  </Grid>
               </Grid>

               <Grid
                  container
                  item
                  xs={12}
                  md={6}
                  lg={6}
                  justifyContent={'center'}
                  alignItems={'center'}
                  sx={{
                     marginLeft: 'auto',
                     marginRight: 'auto',
                     maxWidth: windowWidth >= 900 ? '100%' : (windowWidth < 500 ? 'auto' : (windowWidth > 500 ? '530px' : '500px')),
                     maxHeight: windowWidth >= 900 ? 'auto' : 'auto',
                     height: windowWidth >= 900 ? 'auto' : 'auto',
                     padding: windowWidth >= 900 ? '0px 30px' : '0px 0px 0px 0px',
                     // Readd padding bottom for mobile
                     paddingTop: windowWidth < 900 ? '40px' : '',
                     // paddingBottom: windowWidth > 1280 ? '50px': '70px',
                     zIndex: '10'
                  }}
               >

                  <Elements stripe={stripePromise} options={options}>

                     <div style={{
                        height: 'auto', margin: '0px', width: mobileWidth, minWidth: '290px',
                        maxWidth: '500px',
                     }}>
                        <p style={{
                           fontSize: '20px', width: '100%', fontWeight: '600', letterSpacing: '0px',
                           padding: '0px 0px 0px 0px', textAlign: 'left', margin: '0px 0px 15px 0px'
                        }}>
                           Payment Details
                        </p>
                     </div>

                     <CheckoutForm
                        influencer={props.influencer}
                        price={props.buyCollectionPrice}
                        buyCollectionTitle={props.buyCollectionTitle}
                        currency={props.currency}
                        open_terms={props.open_terms}
                        collection_id={props.buyCollectionId}
                     />
                  </Elements>
               </Grid>
            </Grid>
         </Grid>
      </Modal>
   )
};
